import React from "react";
import { observer } from "mobx-react-lite";
import { Form } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import FakeInput from "@edaz/edazkit/controls/FakeInput";
import { emptyValue } from "utils/emptyValue";
import Section from "views/common/section";
import type PaymentCardGatewayDetailViewModel from "viewModels/finance/payments/cardGateWay/paymentCardGatewayDetailViewModel";

export interface IdentifiersInfoProps {
  vm: PaymentCardGatewayDetailViewModel;
}

const IdentifiersInfo = observer((props: IdentifiersInfoProps) => {
  const { vm } = props;

  return (
    <Section title={vm.translate("identifiersInfoTitle")} context>
      <Form.Row>
        <Form.Group as={Col} sm={3}>
          <Form.Label>{vm.translate("variableSymbol")}</Form.Label>
          <FakeInput target={vm.item} property="variableSymbol" valueFormatter={value => value ?? emptyValue} />
        </Form.Group>
        <Form.Group as={Col} sm={3}>
          <Form.Label>{vm.translate("terminalType")}</Form.Label>
          <FakeInput
            target={vm.item}
            property="terminalType"
            valueFormatter={value => vm.translateTerminalType(value) ?? emptyValue}
          />
        </Form.Group>
        <Form.Group as={Col} sm={3}>
          <Form.Label>{vm.translate("terminalId")}</Form.Label>
          <FakeInput target={vm.item} property="terminalId" valueFormatter={value => value ?? emptyValue} />
        </Form.Group>
        <Form.Group as={Col} sm={3}>
          <Form.Label>{vm.translate("authCode")}</Form.Label>
          <FakeInput target={vm.item} property="authCode" valueFormatter={value => value ?? emptyValue} />
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col} sm={4}>
          <Form.Label>{vm.translate("merchantId")}</Form.Label>
          <FakeInput target={vm.item} property="merchantId" valueFormatter={value => value ?? emptyValue} />
        </Form.Group>
        <Form.Group as={Col} sm={4}>
          <Form.Label>{vm.translate("arn")}</Form.Label>
          <FakeInput target={vm.item} property="arn" valueFormatter={value => value ?? emptyValue} />
        </Form.Group>
        <Form.Group as={Col} sm={4}>
          <Form.Label>{vm.translate("paymentIdent")}</Form.Label>
          <FakeInput target={vm.item} property="paymentIdent" valueFormatter={value => value ?? emptyValue} />
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col} sm={4}>
          <Form.Label>{vm.translate("invoiceNumber")}</Form.Label>
          <FakeInput target={vm.item} property="invoiceNumber" valueFormatter={value => value ?? emptyValue} />
        </Form.Group>
        <Form.Group as={Col} sm={4}>
          <Form.Label>{vm.translate("transferVariableSymbol")}</Form.Label>
          <FakeInput target={vm.item} property="transferVariableSymbol" valueFormatter={value => value ?? emptyValue} />
        </Form.Group>
        <Form.Group as={Col} sm={4}>
          <Form.Label>{vm.translate("transferSpecificSymbol")}</Form.Label>
          <FakeInput target={vm.item} property="transferSpecificSymbol" valueFormatter={value => value ?? emptyValue} />
        </Form.Group>
      </Form.Row>
    </Section>
  );
});

export default IdentifiersInfo;
